import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui";
import StickyBar from "./ui/StickyBar";

export const PROFILE_PERSONAL_FORM_ID = "profile-personal-form";
export const PROFILE_HOST_FORM_ID = "profile-host-form";

/**
 * Mobile thumb-zone save bar for profile Personal and Host tabs.
 * Desktop keeps inline form actions at the end of the scroll.
 */
export default function ProfileStickySaveBar({
  formId,
  saving,
  label,
  dirty = false,
  secondaryLink,
  submitTestId = "sticky-save-profile-btn",
}) {
  return (
    <StickyBar
      testId="profile-sticky-save-bar"
      hideOnDesktop
      aria-busy={saving}
    >
      {dirty ? (
        <p className="font-ui text-[12px] font-medium text-ink/75 text-center mb-1.5" data-testid="profile-unsaved-hint">
          Unsaved changes
        </p>
      ) : null}
      <div className="flex items-stretch gap-2">
        {secondaryLink ? (
          secondaryLink.onNavigate ? (
            <Button
              type="button"
              variant="secondary"
              onClick={secondaryLink.onNavigate}
              className="shrink-0 px-3 text-[13px]"
              data-testid={secondaryLink.testId}
            >
              {secondaryLink.label}
            </Button>
          ) : (
            <Button
              as={Link}
              variant="secondary"
              to={secondaryLink.to}
              className="shrink-0 px-3 text-[13px]"
              data-testid={secondaryLink.testId}
            >
              {secondaryLink.label}
            </Button>
          )
        ) : null}
        <Button
          type="submit"
          form={formId}
          variant="primary"
          disabled={saving}
          className={secondaryLink ? "flex-1 min-w-0 text-[13px]" : "w-full text-[14px]"}
          data-testid={submitTestId}
        >
          <span className="truncate">{saving ? "Saving…" : label}</span>
        </Button>
      </div>
    </StickyBar>
  );
}
